module.exports = __webpack_public_path__ + "static/media/live-site.1515dcd2.svg";